import { Styles } from 'jss';
import { FULL_TEXT_STYLES, TValidationState } from '../../../utils';
import { getFormStateColor } from '../../../styles/form-state-color-styles';

export const getStateMessageStyles = (state: TValidationState): Styles<'message'> => {
  return {
    message: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      marginTop: '5px',
      color: getFormStateColor(state).formStateColor,
      ...FULL_TEXT_STYLES['state-message'].base,
    },
  };
};
